import styled, { keyframes } from 'styled-components';

const growAndShrinkMini = keyframes`
  0% {
    transform: scale(.7);
  }
  50% {
    transform: scale(.8);
  }
  100% {
    transform: scale(.7);
  }
`;
const growAndShrink = keyframes`
  0% {
    transform: scale(1.2);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1.2);
  }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  width: 100vw;
`;
export const MiniLoaderLogo = styled.div`
  animation: pulse 1s infinite;
  animation-direction: alternate;
  animation-name: ${growAndShrinkMini};
  -webkit-animation-name: ${growAndShrinkMini};
`;

export const Logo = styled.div`
  justify-content: center;

  display: flex;
  align-items: center;
  width: 60%;
  animation: pulse 1s infinite;
  animation-direction: alternate;
  animation-name: ${growAndShrink};
  -webkit-animation-name: ${growAndShrink};
`;

export const MiniLoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;
